import React from "react";
import { Survey } from "survey-react-ui";
import { Model } from "survey-core";
import { Box, Grid } from "@mui/material";
import { isNil } from "lodash";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";

import "../styles/noteStyles.css";
import { ClickableEvents, NotePreviewStyle, SurveyStyling } from "../styles/TabsStyle";

export interface SurveyType {
    model: Model;
    title?: string;
}

const NotesPreview: React.FC<SurveyType> = ({
    model,
    title = "notes-preview"
}) => {
    if (!isNil(model)) {
        const survey = model instanceof Model ? model : new Model(model);
        survey.applyTheme(SurveyStyling);
        survey.mode = "edit";
        survey.showCompleteButton = false;
        survey.readOnly = true;

        const setReadOnlyFields = (title: string) => {
            const textareaElements = document.querySelectorAll(
                `.${title} .sd-root-modern__wrapper textarea`
            );
            textareaElements.forEach((el) => {
                const textarea = el as HTMLTextAreaElement;
                textarea.setAttribute("readonly", "readonly");
                textarea.style.pointerEvents = "auto";
            });
            const inputElements = document.querySelectorAll(
                `.${title} .sd-root-modern__wrapper input:not([type=button])`
            );
            inputElements.forEach((el) => {
                const input = el as HTMLInputElement;
                input.setAttribute("readonly", "readonly");
                if (!input.className.includes("dropdown")) {
                    input.style.pointerEvents = "auto";
                }
            });
        };

        survey.onAfterRenderPage.add(() => {
            setReadOnlyFields(title);
        });

        return (
            <Grid container sx={NotePreviewStyle}>
                <Box sx={ClickableEvents} display="contents">
                    <Survey
                        model={survey}
                        className={title}
                    />
                </Box>
            </Grid>
        );
    }

    return <Grid> </Grid>;
};

export default NotesPreview;